<div class="dataprocess-workflow d-flex flex-column h-100 w-100">

  <div *ngIf="isLoading" class="p-2 text-muted">
    {{ 'Lade Workflows…' | translate }}
  </div>

  <div *ngIf="!isLoading" class="dataprocess-workflow-top p-2">
    <app-dataprocess-workflowplan
      [workflows]="workflows"
      [selectedWorkflowId]="selectedWorkflowId"
      [isReadOnly]="isReadOnly"
      (selectedWorkflowIdChanged)="onSelectedWorkflowChanged($event)"
      (createWorkflowRequested)="openCreateWorkflowDialog()"
      (duplicateWorkflowRequested)="openDuplicateWorkflowDialog()"
      (addWorkflowItemRequested)="addWorkflowItemToSelectedWorkflow()"
      (editWorkflowRequested)="openEditWorkflowDialog()"
      (deleteWorkflowRequested)="deleteSelectedWorkflow()"
    ></app-dataprocess-workflowplan>
  </div>

  <div *ngIf="!isLoading" class="dataprocess-workflow-content flex-grow-1 p-2">
    <div *ngIf="!selectedWorkflow" class="text-muted dataprocess-workflow-empty">
      {{ 'Bitte einen Workflow auswählen.' | translate }}
    </div>

    <div *ngIf="selectedWorkflow" class="dataprocess-workflow-items">
      <workflow-items [(workflow)]="selectedWorkflow"></workflow-items>
    </div>
  </div>

  <np-dataprocess-workflow-dialog
    [(visible)]="isWorkflowEditorVisible"
    [workflow]="workflowEditorDraft"
    [title]="workflowEditorTitle"
    (saveRequested)="saveWorkflowEditorDraft()"
    (cancelRequested)="cancelWorkflowEditorDraft()"
  ></np-dataprocess-workflow-dialog>

</div>
